import MicroModal from 'micromodal';

export default MicroModal.init();


// WEBPACK FOOTER //
// ./scripts/routes/microModal.js